import Alert from 'client/components/aria/Alert/Alert';
import { FormattedMessage, useIntl } from 'react-intl';
import defaultAriaProps from 'client/utils/constants/ariaPropTypes';
import Markdown from 'client/components/aria/MarkDown/Markdown';
import { NavLink } from 'react-router';
import { HSG47_PAGE, TERMS_AND_CONDITIONS_PAGE } from 'client/utils/routes/routeConstants';
import Button from 'client/components/aria/Button/Button';
import styles from './HomePage.module.scss';
import WorkspaceStartIcon from './Workspace/WorkspaceStartIcon';

const HomePageAlert = (props) => {
    const intl = useIntl();

    const { content, 'data-testid': dataTestId } = props;

    return (
        <>
            <div className='govuk-!-margin-bottom-4 govuk-body-m'>
                {intl.formatMessage({ id: 'workspace.hsg47.description' }, {
                    linkTerms: str => (
                        <NavLink className={'govuk-link'} rel="noreferrer" to={TERMS_AND_CONDITIONS_PAGE}>{str}</NavLink>
                    )
                })}
            </div>
            <Alert
                title={intl.formatMessage({ id: 'homePageAlert.title' })}
                variant="secondary"
                {...props}
            >
                <Markdown>
                    {content?.markdown}
                </Markdown>
                <Button variant="secondary" className={styles.termsButton} data-testid={`${dataTestId}.button`} to={HSG47_PAGE} aria-label={intl.formatMessage({ id: 'homePageAlert.button' })}>
                    <FormattedMessage id="homePageAlert.button" />
                    <WorkspaceStartIcon/>
                </Button>
            </Alert>
        </>
    );
};

HomePageAlert.propTypes = {
    ...defaultAriaProps
};

export default HomePageAlert;
